export default __webpack_public_path__ + "static/media/camera.dbfced21.svg";